module.exports = __webpack_public_path__ + "img/gold-coin-0ld.515133b2.svg";